import React from "react";
import { Link, NavLink, Outlet, useParams } from "react-router-dom";
import useSWR from "swr";
import LanguageApi from "../components/Language";
const Product = () => {
  let params = useParams();
  const {usagearea, usage_text, packageText, storage, lifetime, contact} = LanguageApi();
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "product.php?product_link=" + params.productName
  );
  if (error) return <div>failed to load</div>
  if (!data) return <div>loading...</div>
  return (
    <div className="product-page">
      <div className="product-head">
        <div className="product-head-f">
          <div className="product-image-page">
            <img
              src={process.env.REACT_APP_DEF_URL+data.product_img}
              alt="Product name"
            />
          </div>
          <div className="product-desc">
            <div className="product-desc-head">
              <h2>{data.product_name}</h2>
                {data.product_future1}
                <br />
                <div className="product-description" dangerouslySetInnerHTML={{__html:data.product_description}}></div>
                <br />
                {data.product_future3}
                <br />
                {data.product_future4}
                <br />
                {data.product_future5}
            </div>
            <div className="product-contact">
              <div className="product-button">
                <Link to={"/contact"}>{contact}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="product-body">
        <div className="product-menu">
          <div className="product-menu-i">
            <span>
              <NavLink className={({ isActive }) => (isActive ? "active" : " passive")} to={"usagearea"}>{usagearea}</NavLink>
            </span>
            <span>
              <NavLink className={({ isActive }) => (isActive ? "active" : " passive")} to={"usage"}>{usage_text}</NavLink>
            </span>
            <span>
              <NavLink className={({ isActive }) => (isActive ? "active" : " passive")} to={"package"}>{packageText}</NavLink>
            </span>
            <span>
              <NavLink className={({ isActive }) => (isActive ? "active" : " passive")} to={"storage"}>{storage}</NavLink>
            </span>
            <span>
              <NavLink className={({ isActive }) => (isActive ? "active" : " passive")} to={"lifetime"}>{lifetime}</NavLink>
            </span>
          </div>
        </div>
        <div className="product-body-b">
          <div className="product-body-in">
            <Outlet/>
          </div>
          
        </div>
        
      </div>
    </div>
  );
};

export default Product;
